var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4C8.3431 4 7 5.3431 7 7C7 8.6569 8.3431 10 10 10C11.6569 10 13 8.6569 13 7C13 5.3431 11.6569 4 10 4ZM9 7C9 6.4477 9.4477 6 10 6C10.5523 6 11 6.4477 11 7C11 7.5523 10.5523 8 10 8C9.4477 8 9 7.5523 9 7Z",
    fill: ""
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.83 6.2807C17.542 2.15186 13.8122 0 10 0C6.18777 0 2.45796 2.15186 0.170031 6.2807C-0.0536292 6.6844 -0.0563893 7.1821 0.160291 7.5876C2.41183 11.8013 6.1628 14 10 14C13.8372 14 17.5882 11.8013 19.8397 7.5876C20.0564 7.1821 20.0536 6.6844 19.83 6.2807ZM10 12C7.06097 12 4.04052 10.3724 2.09173 6.9487C4.06862 3.59614 7.07319 2 10 2C12.9268 2 15.9314 3.59614 17.9083 6.9487C15.9595 10.3724 12.939 12 10 12Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.dface8bae81b4a7f5529b3f79f5f2192.svg";
export { ForwardRef as ReactComponent };